import Guangzhou from "./data/Guangzhou.json";
import Shenzhen from "./data/Shenzhen.json";
import Dongguan from "./data/Dongguan.json";
import Foshan from "./data/Foshan.json";
import Zhongshan from "./data/Zhongshan.json";
import Zhuhai from "./data/Zhuhai.json";
import Shantou from "./data/Shantou.json";
import Jiangmen from "./data/Jiangmen.json";
import Zhanjiang from "./data/Zhanjiang.json";
import Shaoguan from "./data/Shaoguan.json";
import Qingyuan from "./data/Qingyuan.json";
import Chaozhou from "./data/Chaozhou.json";
import Jieyang from "./data/Jieyang.json";
import Maoming from "./data/Maoming.json";
import Zhaoqing from "./data/Zhaoqing.json";
import Huizhou from "./data/Huizhou.json";
import Meizhou from "./data/Meizhou.json";
import Shanwei from "./data/Shanwei.json";
import Yangjiang from "./data/Yangjiang.json";
import Heyuan from "./data/Heyuan.json";
import Yunfu from "./data/Yunfu.json";

export default{ 
    Guangzhou,
    Shenzhen,
    Dongguan,
    Foshan,
    Zhongshan,
    Zhuhai,
    Shantou,
    Jiangmen,
    Zhanjiang,
    Shaoguan,
    Qingyuan,
    Chaozhou,
    Jieyang,
    Maoming,
    Zhaoqing,
    Huizhou,
    Meizhou,
    Shanwei,
    Yangjiang,
    Heyuan,
    Yunfu
}
